import {useNavigate} from "react-router-dom";
import {Button, Col, Input, Row, Space, Spin, Typography} from "antd";
import {useEffect, useState} from "react";
import {PlusOutlined} from "@ant-design/icons";
import EmployeeTable from "./EmployeeTable";
import {  useDeleteQuery, useGetQuery} from "../../service/query/Queries";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
const {Title}=Typography

const Office = () => {

    const navigate = useNavigate()
    const {data,isLoading:getLoading,refetch}=useGetQuery(false,'employee-get',`/employee` , false)
    const [search, setSearch] = useState([]);
    const [isSearch, setIsSearch] = useState(false);
    const ScreenMD = useBreakpoint().md;




    useEffect(() => {
        refetch()
    }, []);


    const searchFunc = (value) => {
        if (value === '') {
            setIsSearch(false);
        } else {
            setIsSearch(true);
        }
        const filterData = data?.filter(
            (data) => data?.user_name.toLowerCase().includes(value.toLowerCase()));
        setSearch(filterData);
    };

    return (
        <div className={'site-space-compact-wrapper'}>
            <Space direction={'vertical'} size={"large"} style={{width: '100%'}}>
                <Row gutter={[10 , 20]}>
                    <Col span={18}>
                        <Title className={'page--title'} level={2}>
                            Офис
                        </Title>
                    </Col>
                    {/*<FilterCompanyForAdmin/>*/}
                    <Col span={ 16 }>
                        <Input placeholder="Поиск сотрудник" onChange={(e) => searchFunc(e.target.value)} />
                    </Col>
                    {/*<Col span={8}>*/}
                    {/*    <Button*/}
                    {/*        type='primary'*/}
                    {/*        icon={<PlusOutlined/>}*/}
                    {/*        style={{width: '100%'}}*/}
                    {/*        onClick={addArticle}>*/}
                    {/*        {*/}
                    {/*            ScreenMD && 'Добавить'*/}
                    {/*        }*/}
                    {/*    </Button>*/}
                    {/*</Col>*/}

                </Row>
                <Spin
                    size='medium'
                    spinning={getLoading }>
                    <EmployeeTable
                        data={isSearch ? search : data}
                    />
                </Spin>
            </Space>
        </div>
    );
};

export default Office;